/*
 * Date: 2020-08-02 10:10:14
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-02 13:39:15
 * Description: In User Settings Edit
 * Author: Mosuzi
 */
export default {
  data () {
    return {
      orgId: ''
    }
  },
  created() {
    this.orgId = this.$route.params.orgId
  }
}
